import React from "react";
import mainStyle from "../../dashboard.module.scss";
import { useTheme } from "@mui/material/styles";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import icn_grid_chart from "assets/images/icons/icn_grid_chart.svg";
import { mockAlerts } from "../../const";

const AlertLog = ({ sortable, alerts = mockAlerts }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
      className={`main-card-content ${mainStyle["dndObj_card"]} ${
        sortable === true ? mainStyle["dndObj_edit"] : ""
      }`}
    >
      <Box className={mainStyle["dndObj_title"]} sx={{ display: "flex", alignItems: "center" }}>
        <img src={icn_grid_chart} alt="alert_log_icon" />
        <Typography component="span" sx={{ marginLeft: "10px" }}>Alert Log</Typography>
      </Box>

      <Box sx={{ flexGrow: 1, overflow: "hidden", px: 0, pb: 0, mt: 1.5 }}>
        <TableContainer
          sx={{
            maxHeight: "100%",
            overflowY: "auto",
            "&::-webkit-scrollbar": {
              width: "6px",
              height: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0, 0, 0, 0.35)",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "transparent",
            },
          }}
        >
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary", pl: 2 }}>Type</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary" }}>Level</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary" }}>Content</TableCell>
                <TableCell sx={{ fontWeight: "bold", backgroundColor: "#E8E8E8", color: "text.primary", pr: 2 }}>Time</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {alerts.map((row, idx) => {
                return (
                  <TableRow key={idx}>
                    <TableCell sx={{ fontSize: "13px", pl: 2 }}>{row.type}</TableCell>
                    <TableCell
                      sx={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        color:
                          row.level === "Critical"
                            ? theme.palette.primary.redPrimary
                            : row.level === "Major"
                            ? theme.palette.primary.orange
                            : row.level === "Warning"
                            ? "#D4B106"
                            : theme.palette.primary.greyThird,
                      }}
                    >
                      {row.level}
                    </TableCell>
                    <TableCell sx={{ fontSize: "13px", maxWidth: "160px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {row.content}
                    </TableCell>
                    <TableCell sx={{ fontSize: "13px", color: "text.secondary", whiteSpace: "nowrap", pr: 2 }}>
                      {row.time}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default AlertLog;
